import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    AMBULANCE_MAINTENANCE_PLATES,
    AMBULANCE_MAINTENANCE_CHASIS,
    AMBULANCE_MAINTENANCE_CODE_IGSS,
    AMBULANCE_MAINTENANCE_LIST,
    AMBULANCE_MAINTENANCE_DETAIL,
    AMBULANCE_MAINTENANCE_UPDATE,
} from "../../actions";

import {
    AmbulanceMaintenancePlatesSuccess,
    AmbulanceMaintenancePlatesError,
    AmbulanceMaintenanceChasisSuccess,
    AmbulanceMaintenanceChasisError,
    AmbulanceMaintenanceCodeIgssSuccess,
    AmbulanceMaintenanceCodeIgssError,
    AmbulanceMaintenanceListSuccess,
    AmbulanceMaintenanceListError,
    AmbulanceMaintenanceDetailSuccess,
    AmbulanceMaintenanceDetailError,
    AmbulanceMaintenanceDetail,
    AmbulanceMaintenanceUpdateSuccess,
    AmbulanceMaintenanceUpdateError,
} from '../../actions';

export function* watchAmbulanceMaintenancePlates() {
    yield takeEvery(AMBULANCE_MAINTENANCE_PLATES, onAmbulanceMaintenancePlates);
}
export function* watchAmbulanceMaintenanceChasis() {
    yield takeEvery(AMBULANCE_MAINTENANCE_CHASIS, onAmbulanceMaintenanceChasis);
}
export function* watchAmbulanceMaintenanceCodeIgss() {
    yield takeEvery(AMBULANCE_MAINTENANCE_CODE_IGSS, onAmbulanceMaintenanceCodeIgss);
}
export function* watchAmbulanceMaintenanceList() {
    yield takeEvery(AMBULANCE_MAINTENANCE_LIST, onAmbulanceMaintenanceList);
}
export function* watchAmbulanceMaintenanceDetail() {
    yield takeEvery(AMBULANCE_MAINTENANCE_DETAIL, onAmbulanceMaintenanceDetail);
}
export function* watchAmbulanceMaintenanceUpdate() {
    yield takeEvery(AMBULANCE_MAINTENANCE_UPDATE, onAmbulanceMaintenanceUpdate);
}

const getToken = async (auth) => {
    return await auth.currentUser.getIdToken(true);
};

const onAmbulanceMaintenancePlatesAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/plates', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceMaintenanceChasisAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/chasis', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceMaintenanceCodeIgssAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/codeigss', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceMaintenanceListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ page: payload.page, num_page: payload.num_page, filters: payload.filters }),
    });
    return await response.json();
};

const onAmbulanceMaintenanceDetailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ id_ambulance: payload.id_ambulance }),
    });
    return await response.json();
};

const onAmbulanceMaintenanceUpdateAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceMaintenance/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ ...data }),
    });
    return await response.json();
};

function* onAmbulanceMaintenancePlates() {
    try {
        const response = yield call(onAmbulanceMaintenancePlatesAsync);
        yield put(AmbulanceMaintenancePlatesSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceMaintenancePlatesError(error));
    }
}

function* onAmbulanceMaintenanceChasis() {
    try {
        const response = yield call(onAmbulanceMaintenanceChasisAsync);
        yield put(AmbulanceMaintenanceChasisSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceMaintenanceChasisError(error));
    }
}

function* onAmbulanceMaintenanceCodeIgss() {
    try {
        const response = yield call(onAmbulanceMaintenanceCodeIgssAsync);
        yield put(AmbulanceMaintenanceCodeIgssSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceMaintenanceCodeIgssError(error));
    }
}

function* onAmbulanceMaintenanceList({ payload }) {
    try {
        const response = yield call(onAmbulanceMaintenanceListAsync, payload);
        yield put(AmbulanceMaintenanceListSuccess(response));
    } catch (error) {
        yield put(AmbulanceMaintenanceListError(error));
    }
}

function* onAmbulanceMaintenanceDetail({ payload }) {
    try {
        const response = yield call(onAmbulanceMaintenanceDetailAsync, payload);
        yield put(AmbulanceMaintenanceDetailSuccess(response));
    } catch (error) {
        yield put(AmbulanceMaintenanceDetailError(error));
    }
}

function* onAmbulanceMaintenanceUpdate({ payload }) {
    try {
        const response = yield call(onAmbulanceMaintenanceUpdateAsync, payload.data);
        if (response && response.status) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(AmbulanceMaintenanceUpdateSuccess(response));
            // Reload the detail so the maintenance table stays in sync
            if (payload.id_ambulance) {
                yield put(AmbulanceMaintenanceDetail({ id_ambulance: payload.id_ambulance }));
            }
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(AmbulanceMaintenanceUpdateError(response));
        }
    } catch (error) {
        yield put(AmbulanceMaintenanceUpdateError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchAmbulanceMaintenancePlates),
        fork(watchAmbulanceMaintenanceChasis),
        fork(watchAmbulanceMaintenanceCodeIgss),
        fork(watchAmbulanceMaintenanceList),
        fork(watchAmbulanceMaintenanceDetail),
        fork(watchAmbulanceMaintenanceUpdate),
    ]);
}
